import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import utils from '../../../utils/utils';
import DATE_FORMAT from '../../../components/constants/dateFormat';

function DeliverySmsHistory({ delivery }) {
  return (
    <div>
      <h2 className="m-b-6">
        <FormattedMessage id={'delivery.sms.modal.title'} values={{ deliveryId: delivery.id }} />
      </h2>

      <div className="m-b-6">
        {delivery.smses.map((sms) => (
          <>
            <div>{utils.getDateFromString(sms.dateCreated).format(DATE_FORMAT.displayWithTime)}</div>
            <div>{sms.status}</div>
            <div className="alert alert-info m-b-3">
              <div>{sms.content}</div>
            </div>
          </>
        ))}
      </div>
    </div>
  );
}

export default injectIntl(DeliverySmsHistory);
